import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message, Spin, Radio, Space } from "antd";
import { ALSFRS_FIELDS } from "../../utils/consts";
import Bridge from "../../utils/Bridge";

export default class CpibForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      condition_talking_with_people_you_know: "",
      condition_communicate_need_say_quickly: "",
      condition_talking_with_people_do_not_know: "",
      communicating_out_in_your_community: "",
      condition_asking_questions_conversation: "",
      communicate_with_small_group_people: "",
      long_communication_of_book_movie: "",
      giving_detailed_information: "",
      getting_turn_fast_moving_conversation: "",
      persuade_friend_different_points_of_view: "",
      total_score: 0,

      options: [
        {
          label: "Not at all (3)",
          value: "3",
        },
        {
          label: "A little (2)",
          value: "2",
        },
        { label: "Quite a bit (1)", value: "1" },
        { label: "Very much (0)", value: "0" },
      ],
    };
  }
  save_cpib_form = () => {
    if (
      this.state.condition_talking_with_people_you_know === "" &&
      this.state.condition_talking_with_people_you_know !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..talking with people you know' field"
      );
      return;
    }
    if (
      this.state.condition_communicate_need_say_quickly === "" &&
      this.state.condition_communicate_need_say_quickly !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..communicating when you need to say something quickly' field"
      );
      return;
    }
    if (
      this.state.condition_talking_with_people_do_not_know === "" &&
      this.state.condition_talking_with_people_do_not_know !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..talking with people you don NOT know' field"
      );
      return;
    }
    if (
      this.state.communicating_out_in_your_community === "" &&
      this.state.communicating_out_in_your_community !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..communicating when you are out in your community' field"
      );
      return;
    }
    if (
      this.state.condition_asking_questions_conversation === "" &&
      this.state.condition_asking_questions_conversation !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..asking questions in a conversation' field"
      );
      return;
    }
    if (
      this.state.communicate_with_small_group_people === "" &&
      this.state.communicate_with_small_group_people !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..communicating in a small group of people' field. "
      );
      return;
    }
    if (
      this.state.long_communication_of_book_movie === "" &&
      this.state.long_communication_of_book_movie !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..having a long conversation with someone you know about a book' field"
      );
      return;
    }
    if (
      this.state.giving_detailed_information === "" &&
      this.state.giving_detailed_information !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..giving someone DETAILED information' field"
      );
      return;
    }
    if (
      this.state.getting_turn_fast_moving_conversation === "" &&
      this.state.getting_turn_fast_moving_conversation !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..getting your turn in a last-moving conversation' field"
      );
      return;
    }
    if (
      this.state.persuade_friend_different_points_of_view === "" &&
      this.state.persuade_friend_different_points_of_view !== 0
    ) {
      message.warning(
        "Please select value of 'Does your condition interface with.. ..trying to persuade a friend or family member to..' field "
      );
      return;
    }

    let params = {
      condition_talking_with_people_you_know:
        this.state.condition_talking_with_people_you_know,
      condition_communicate_need_say_quickly:
        this.state.condition_communicate_need_say_quickly,
      condition_talking_with_people_do_not_know:
        this.state.condition_talking_with_people_do_not_know,
      communicating_out_in_your_community:
        this.state.communicating_out_in_your_community,
      condition_asking_questions_conversation:
        this.state.condition_asking_questions_conversation,
      communicate_with_small_group_people:
        this.state.communicate_with_small_group_people,
      long_communication_of_book_movie:
        this.state.long_communication_of_book_movie,
      giving_detailed_information: this.state.giving_detailed_information,
      getting_turn_fast_moving_conversation:
        this.state.getting_turn_fast_moving_conversation,
      persuade_friend_different_points_of_view:
        this.state.persuade_friend_different_points_of_view,
      eals_id: localStorage.getItem("ap_eals_id"),
    };

    this.setState({ loading: true });
    Bridge.cpib_form
      .save(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              condition_talking_with_people_you_know: "",
              condition_communicate_need_say_quickly: "",
              condition_talking_with_people_do_not_know: "",
              communicating_out_in_your_community: "",
              condition_asking_questions_conversation: "",
              communicate_with_small_group_people: "",
              long_communication_of_book_movie: "",
              giving_detailed_information: "",
              getting_turn_fast_moving_conversation: "",
              persuade_friend_different_points_of_view: "",
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 2000);
            }
          );
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <Spin spinning={this.state.loading}>
                  <div className="demographic-single-section">
                    <a
                      href="/dashboard"
                      style={{ width: 95 }}
                      className="back-arrow"
                    >
                      <box-icon
                        name="chevron-left"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                      Back
                    </a>
                    <div>
                      <div className="header">
                        <h3>ADD Cpib Form</h3>
                        <div className="white-block"></div>
                      </div>
                      <Spin spinning={this.state.loading}>
                        <div className="form-fields">
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              1. Does your condition interface with.. ..talking
                              with people you know?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  condition_talking_with_people_you_know:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .condition_talking_with_people_you_know
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              2. Does your condition interface with..
                              ..communicating when you need to say something
                              quickly?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  condition_communicate_need_say_quickly:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .condition_communicate_need_say_quickly
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              3. Does your condition interface with.. ..talking
                              with people you don NOT know?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  condition_talking_with_people_do_not_know:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .condition_talking_with_people_do_not_know
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              4. Does your condition interface with..
                              ..communicating when you are out in your
                              community(e.g.errands, appointments)?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  communicating_out_in_your_community:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state.communicating_out_in_your_community
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              5. Does your condition interface with.. ..asking
                              questions in a conversation?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  condition_asking_questions_conversation:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .condition_asking_questions_conversation
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              6. Does your condition interface with..
                              ..communicating in a small group of people?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  communicate_with_small_group_people:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state.communicate_with_small_group_people
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              7. Does your condition interface with.. ..having a
                              long conversation with someone you know about a
                              book, movie, show or sports event?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  long_communication_of_book_movie:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state.long_communication_of_book_movie
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              8. Does your condition interface with.. ..giving
                              someone DETAILED information?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  giving_detailed_information: e.target.value,
                                })
                              }
                              value={this.state.giving_detailed_information}
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              9. Does your condition interface with.. ..getting
                              your turn in a last-moving conversation?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  getting_turn_fast_moving_conversation:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state.getting_turn_fast_moving_conversation
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="form-group">
                            <label className="mb-2 input-heading">
                              10. Does your condition interface with.. ..trying
                              to persuade a friend or family member to see a
                              diffrent point of view?
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  persuade_friend_different_points_of_view:
                                    e.target.value,
                                })
                              }
                              value={
                                this.state
                                  .persuade_friend_different_points_of_view
                              }
                              direction="vertical"
                            >
                              <Space direction="vertical">
                                {this.state.options.map((single, i) => {
                                  return (
                                    <Radio value={single.value} index={i}>
                                      {single.label}
                                    </Radio>
                                  );
                                })}
                              </Space>
                            </Radio.Group>
                          </div>
                          <div className="d-flex mt-5">
                            <button
                              className="submit-button ml-2"
                              style={{
                                marginLeft: 0,
                                padding: "9px 15px 10px 20px",
                              }}
                              onClick={() => this.save_cpib_form()}
                            >
                              Save{" "}
                              <box-icon
                                name="chevron-right"
                                color="#fff"
                                style={{ position: "relative", top: 1 }}
                              ></box-icon>
                            </button>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
